import { render, staticRenderFns } from "./videl.vue?vue&type=template&id=0af2ebaa&scoped=true"
import script from "./videl.vue?vue&type=script&lang=js"
export * from "./videl.vue?vue&type=script&lang=js"
import style0 from "./videl.vue?vue&type=style&index=0&id=0af2ebaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2ebaa",
  null
  
)

export default component.exports